import React from 'react'
import { TextField } from '@mui/material'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'

const filter = createFilterOptions()

export default function CreateableAutocompleteDropdown({value, setValue, dropdownOptions, placeholder, disableCreation = false, size}) {

  const changeValue = (event, newValue) => {
    if (newValue && newValue.inputValue) {
      // Create a new value from the user input
      setValue({
        name: newValue.inputValue,
      })
    } else {
      setValue(newValue)
    }
  }

  const filterOptions = (options, params) => {
    const filtered = filter(options, params)
    const { inputValue } = params
    const isExisting = options.some((option) => inputValue === option.name)
    if (inputValue !== '' && !disableCreation && !isExisting) {
      filtered.push({
        inputValue: inputValue,
        name: `Add "${inputValue}"`,
      })
    }
    return filtered
  }

  const getOptionLabel = (option) => {
    // Value selected with enter, right from the input
    if (typeof option === 'string') {
      return option;
    }
    // Add "xxx" option created dynamically
    if (option.inputValue) {
      return option.inputValue
    }
    // Regular option
    return option.name
  }

  const renderInput = (params) => <TextField {...params} placeholder={placeholder} variant="outlined"/>

  const renderOption = (props, option) => <li {...props} key={option.uuid}>{option.name}</li>

  return (
    <Autocomplete
      value={value}
      onChange={changeValue}
      filterOptions={filterOptions}
      selectOnFocus
      clearOnBlur
      size={size}
      handleHomeEndKeys
      options={dropdownOptions}
      getOptionLabel={getOptionLabel}
      renderOption={renderOption}
      renderInput={renderInput}
    />
  )
}